import React from 'react';
import Loader from '@/components/common/Loader';
import LoaderSizes from '@/constants/ui/LoaderSizes';

export default function ConstituentConnectingLoader({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <div className="flex">
      <span className="mr-2 inline-block text-text-disabled">{children}</span>

      <Loader size={LoaderSizes.SM} />
    </div>
  );
}
